<template>
    <div class="page econfirm">
        <div class="container">
            <div class="h1">
                Confirm details
            </div>
            <div class="descktopMediaBox tableHead">
                <div class="gift">
                    Gift
                </div>
                <div class="recipient">
                    Recipient
                </div>
                <div class="date">
                    Delivery Date
                </div>
                <div class="amount">
                    Amount
                </div>
            </div>
            <div class="glist" v-if="giftCardData.cards.length">
                <div class="gcard" v-for="(gcard,index) in giftCardData.cards">
                    <div class="frame">
                        <img :src="gcard.imgDef" alt="">
                    </div>
                    <div class="recipinet">
                        <div class="title h2">
                            Recipient
                        </div>
                        {{ gcard.recipient_email }}
                    </div>
                    <div class="deliveryDate">
                        <div class="title h2">
                            Delivery Date
                        </div>
                        {{ gcard.delivery_date_object.format("MMMM Do, YYYY") }}
                    </div>
                    <div class="amm">
                        <div class="title h2">
                            Amount
                        </div>
                        ${{ gcard.amount }}
                    </div>
                </div>
            </div>
            <div class="botFlex">
                <div class="subtotal">
                    <div class="title h2">
                        Total: ${{ giftCardData.subTotal() }}
                    </div>
                </div>
                <div class="btnBox">
                    <button class="smlBtn" @click.prevent="econfirm">
                        confirm
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "EgiftConfirm",
        created() {
            this.$store.commit("shared/setTopBar", {title: "Send an E-Gift", showBackButton: true, showBag: false});
            if(!this.$store.state.giftcard.giftCardData.cards.length){
                this.$router.push({name: 'E-gifts'})
            }
        },
        computed: {
            giftCardData() {
                return this.$store.state.giftcard.giftCardData;
            }
        },
        methods: {
            econfirm(){
                let cardList = this.$store.state.giftcard.giftCardData.cards;
                for (var i in cardList) {
                    cardList[i].amount = parseInt(cardList[i].amount);
                    if(cardList.length == i+1){
                        break;
                    }
                }
                //console.log(this.$store.state.giftcard.giftCardData, null, "\t");
                this.$store.dispatch("giftcard/buyGiftCards",{
                    callback: (cards) => {
                        this.$router.push({name: 'EgiftThanks'});
                        setTimeout(()=>{
                            this.$store.commit("giftcard/resetGcart");
                            this.$store.commit("cart/resetCart");
                        },1100)
                    }
                });
            }
        }
    }
</script>

